"use strict";
Shopify.theme.jsHeader = {
  init: function init($section) {
    Shopify.theme.jsHeader = $.extend(
      this,
      Shopify.theme.getSectionData($section)
    ); // Selectors
    this.$el = $("#mobile-header");
    this.$menuToggle = this.$el.find(".header__menu-toggle");
    this.$mobileMenuToggle = $("[data-show-mobile-menu]");
    this.$mobileMenuIcon = $(".mobile-menu__toggle-icon");
    this.$mobileDropDownToggle = $(".mobile-menu .close-dropdown");
    $("body").on("click", '[data-show-mobile-menu="false"]', function () {
      Shopify.theme.jsHeader.open();
    });
    $("body").on("click", '[data-show-mobile-menu="true"]', function () {
      Shopify.theme.jsHeader.close();
    });
    $("body").on("click", ".mobile-menu-link", function (e) {
      e.preventDefault();
    });

    //SET CONTACT BUTTON LINK
    let $contactButtons = [];
    let $scrollContactButtons = [];
    let contact_link = "";
    let sectionExist = false;
    if ($(".jsCustomContactForm:not(.career-form)").length) {
      contact_link = `#contact`;
      sectionExist = true;
    } else {
      contact_link = `/pages/${this.contact_page_handle}`;
    }
    $("[data-contact-button]").attr("href", contact_link);
    $(`.button[data-close-menu]`).attr("href", contact_link);
    $contactButtons = $(`.button[href="${contact_link}"]`);
    $scrollContactButtons = $(`.button[data-close-menu]`);
    $contactButtons.on("click", function (e) {
      if (typeof $(this).data("close-menu") !== "undefined") {
        Shopify.theme.jsHeader.close();
      }
      if (Shopify.theme.jsQuotePopup) {
        Shopify.theme.jsQuotePopup.open();
        e.preventDefault();
      } else {
      }
    });
    $scrollContactButtons.on("click", function (e) {
      Shopify.theme.jsHeader.close();
      Shopify.theme.jsQuotePopup.open();
      e.preventDefault();
    });
    let careerLink = `#career`;
    let careerExist = false;
    if (`.button[href="${careerLink}"]`) {
      let $careerBtn = $(`.button[href="${careerLink}"]`);
      $careerBtn.on("click", function () {
        $([document.documentElement, document.body]).animate(
          {
            scrollTop:
              $(careerLink).offset().top - $("#mobile-header").outerHeight(),
          },
          300
        );
      });
    }

    if (Shopify.theme.jsHeader.enable_sticky === true) {
      this.enableSticky();
    }
    if (Shopify.theme.jsHeader.sectionUnderlayIsImage()) {
      Shopify.theme.jsHeader.enableOverlayStyle();
    }
  },
  open: function open() {
    //Get current position on page
    var currentScrollPosition = window.scrollY;
    $("body").data("current-position", currentScrollPosition);
    window.scrollTo(0, 0);

    $(".mobile-logo-main").addClass("is-covered");
    var announcementHeight = 0;
    var mobileHeaderHeight = parseInt($(".mobile-header").height());

    if (
      typeof Shopify.theme.jsAnnouncementBar !== "undefined" &&
      Shopify.theme.jsAnnouncementBar.enable_sticky
    ) {
      announcementHeight =
        Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }

    this.$mobileMenuIcon.addClass("is-active");
    $("[data-show-mobile-menu]").attr("data-show-mobile-menu", true);
    $(".mobile-dropdown").addClass("is-active");

    if (typeof Shopify.theme.jsAjaxCart !== "undefined") {
      Shopify.theme.jsAjaxCart.hideMiniCart();
      Shopify.theme.jsAjaxCart.hideDrawer();
    } //Set delay on menu open to get proper page position
    setTimeout(function () {
      $("body").addClass("mobile-menu--opened");
    }, 800);
  },
  close: function close() {
    $("body").removeClass("mobile-menu--opened"); // Once mobile menu is closed, return back to previous position on page
    $(".mobile-logo-main").removeClass("is-covered");

    var lastScrollPosition = $("body").data("current-position");
    window.scrollTo(0, lastScrollPosition);
    this.$mobileMenuIcon.removeClass("is-active");
    $(".mobile-dropdown").removeClass("is-active");
    $("[data-show-mobile-menu]").attr("data-show-mobile-menu", false);
  },
  disableSticky: function disableSticky() {
    var $stickyEl = $("#mobile-header");
    $stickyEl.unstick();
    $stickyEl.removeClass("sticky--enabled");
    setTimeout(function () {
      $(".header-sticky-wrapper").css("height", "auto");
    }, 250);
  },
  enableSticky: function enableSticky(offset) {
    var _this2 = this;
    let lastScrollTop = 0;
    let $stickyEl = {};
    $(window).scroll(function (event) {
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        if ($stickyEl) {
          disableSticky();
        }
      } else if (st == lastScrollTop) {
        //do nothing
      } else {
        initSticky();
      }
      lastScrollTop = st;
    });

    function initSticky() {
      $stickyEl = _this2.$el;
      if ($stickyEl.hasClass("sticky--enabled")) {
        return;
      }
      $stickyEl.addClass("sticky--enabled");
      $stickyEl
        .sticky({
          wrapperClassName: "header-sticky-wrapper",
          zIndex: 40,
          topSpacing: offset || 0,
        })
        .on("sticky-start", function () {
          var headerHeight;
          var announcementHeight; // Hide the mini cart for centered header layout

          if (Shopify.theme_settings.header_layout == "centered") {
            $("[data-ajax-cart-trigger]").removeClass("show-mini-cart");
          } // Get header height is sticky enabled

          if (
            Shopify.theme.jsHeader.enable_sticky == true &&
            Shopify.theme_settings.header_layout != "vertical"
          ) {
            headerHeight = Shopify.theme.jsHeader.getHeaderHeight();
          } // Get announcement height is sticky enabled

          if (
            typeof Shopify.theme.jsAnnouncementBar !== "undefined" &&
            Shopify.theme.jsAnnouncementBar.enable_sticky == true &&
            Shopify.theme_settings.header_layout != "vertical"
          ) {
            announcementHeight =
              Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
          }

          var totalHeight = headerHeight + announcementHeight;
          $stickyEl
            .parent()
            .parent()
            .find(".search-overlay")
            .addClass("sticky-search")
            .css("top", totalHeight + "px");

          if (
            _this2.enable_overlay === true &&
            _this2.sectionUnderlayIsImage() === true
          ) {
            $stickyEl.parent().addClass("has-overlaid-header");

            _this2.disableOverlayStyle();
          } else if (_this2.enable_overlay === true) {
            _this2.disableOverlayStyle();
          }
        })
        .on("sticky-end", function () {
          $stickyEl
            .parent()
            .parent()
            .find(".search-overlay")
            .removeClass("sticky-search")
            .css("top", "100%"); // Safety timeout for logo width transition which can throw calculated height off

          setTimeout(function () {
            $stickyEl.sticky("update");
          }, 250);

          _this2.$el.find(".sticky-menu-wrapper").removeClass("is-visible");

          _this2.$menuToggle.removeClass("is-active");

          if (
            _this2.enable_overlay === true &&
            _this2.sectionUnderlayIsImage() === true
          ) {
            _this2.updateOverlayStyle(_this2.sectionUnderlayIsImage());
          }
        });
    }

    function disableSticky() {
      if (!_this2.$el.hasClass("sticky--enabled")) {
        return;
      }
      $stickyEl.css("top", `-${$stickyEl.height()}px`);
      setTimeout(function () {
        $stickyEl.removeClass("sticky--enabled").unstick();
      }, 300);
    }
  },
  disableOverlayStyle: function disableOverlayStyle() {
    $("[data-enable_overlay]").attr("data-enable_overlay", false);
  },
  enableOverlayStyle: function enableOverlayStyle() {
    $("[data-enable_overlay]").attr("data-enable_overlay", true);
  },
  updateOverlayStyle: function updateOverlayStyle(overlayBoolean) {
    $("[data-enable_overlay]").attr("data-enable_overlay", overlayBoolean);
  },
  sectionUnderlayIsImage: function sectionUnderlayIsImage() {
    var $firstSection = $("[data-check-for-order=true]")
      .find("[id^=shopify-section]")
      .first(); // Check whether the first element has class to indicate it should be under header when overlay is enabled

    if (
      $firstSection.hasClass("overlaid-header-option") &&
      $.trim($firstSection.html()).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  },
  getHeaderHeight: function getHeaderHeight() {
    var headerHeight = $(".header-section").outerHeight() || 0;
    return headerHeight;
  },
  unload: function unload($section) {
    $("[data-mobilemenu-toggle]").off();
    $(".mobile-menu__toggle-icon").off();
    $(".mobile-menu .close-dropdown").off();
    this.disableSticky();
  },
};
